import React from "react";
import ArchivePageHeaderDescription from "archive/components/ArchivePageHeaderDescription";
import ArchiveBackends from "archive/components/ArchiveBackends";
import {
  useArchiveBackends,
  deleteArchiveBackend,
  useInvalidateArchiveBackends
} from "archive/hooks/useArchiveBackends";
import { PAGE_SIZES } from "archive/hooks/useArchivesQuery";
import AppConfig from "util/AppConfig";
import { DocumentTitle, PageHeader, Spinner, LinkContainer } from "components/common";
import { Button, Row, Col } from "components/bootstrap";
import usePaginationQueryParameter from "hooks/usePaginationQueryParameter";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { LICENSE_SUBJECTS } from "license/constants";
import LicenseCheck from "license/LicenseCheck";
import { ARCHIVE_LICENSE_WARNING_TITLE, ARCHIVE_LICENSE_WARNING_TEXT } from "archive/constants";
import ArchivePageNavigation from "./components/ArchivePageNavigation";
import ArchiveRoutes from "./Routes";
const isCloud = AppConfig.isCloud();
const ArchiveBackendsPage = () => {
  const { page, pageSize } = usePaginationQueryParameter(PAGE_SIZES);
  const sendTelemetry = useSendTelemetry("backend-configuration");
  const { data: backends } = useArchiveBackends(page, pageSize);
  const invalidateBackends = useInvalidateArchiveBackends();
  const _onDelete = (backend, deleteArchives) => {
    deleteArchiveBackend(backend, deleteArchives).then(() => {
      invalidateBackends();
      sendTelemetry(TELEMETRY_EVENT_TYPE.ARCHIVE.BACKEND_CONFIGURATION_DELETED, {
        app_pathname: "archive"
      });
    });
  };
  if (!backends) {
    return /* @__PURE__ */ React.createElement(Spinner, { text: "Loading backends" });
  }
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: "Archive backend configuration" }, /* @__PURE__ */ React.createElement(ArchivePageNavigation, null), /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "Edit archive backend configuration",
      actions: !isCloud && /* @__PURE__ */ React.createElement(LinkContainer, { to: ArchiveRoutes.BACKENDS.CREATE }, /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary" }, "Create backend"))
    },
    /* @__PURE__ */ React.createElement(ArchivePageHeaderDescription, null)
  ), /* @__PURE__ */ React.createElement(
    LicenseCheck,
    {
      text: ARCHIVE_LICENSE_WARNING_TEXT,
      title: ARCHIVE_LICENSE_WARNING_TITLE,
      licenseSubject: LICENSE_SUBJECTS.archive,
      displayWarningContainer: true,
      bsStyle: "danger"
    }
  ), /* @__PURE__ */ React.createElement(Row, { className: "content archive-backends" }, /* @__PURE__ */ React.createElement(Col, { lg: 12 }, /* @__PURE__ */ React.createElement(ArchiveBackends, { backends: backends.backends, pagination: backends.pagination, onDelete: _onDelete }))));
};
export default ArchiveBackendsPage;
